import { FINAL_CLASS_CREATION_STATUSES } from '../data/classCreationStatuses';

function areAllScheduledClassesProcessed(classStatuses) {
  if (classStatuses) {
    return Object.values(classStatuses).every((status) =>
      FINAL_CLASS_CREATION_STATUSES.includes(status)
    );
  } else {
    return false;
  }
}

export default areAllScheduledClassesProcessed;
